import React from 'react';
import PropTypes from 'prop-types';
import NomnationsEditor from './Share/NominationsEditor';
import useTitle from '../../Title/hooks/useTitle';
import ResponsiveDrawerAnchor from '../../UI/ResponsiveDrawerAnchor';
import UserReviewEditorProvider, {
	useUserReviewEditor,
} from './data/UserReviewEditorProvider';
import CommunityButton from '../../UI/CommunityButton';
import { Icon, Button, message } from 'antd';
import delay from '../../../util/delay';
import './nominationsEditorAnchor.css';
import LoadingSpinnerInContainer from '../../UI/LoadingSpinnerInContainer';

NominationsEditorAnchor.propTypes = {
	sku: PropTypes.string,
	onUpdate: PropTypes.func,
	children: PropTypes.element,
};

SubmitNominationsButton.propTypes = {
	productName: PropTypes.string,
	drawer: PropTypes.shape({ close: PropTypes.func }),
};

function SubmitNominationsButton({ drawer, productName }) {
	const [isSaving, setIsSaving] = React.useState(false);

	const { editorController } = useUserReviewEditor();

	const handleSave = async () => {
		setIsSaving(true);

		await editorController.save({
			fallbackOverallRating: 9,
			doSubmitSharingState: false,
		});

		message.success(`Nominations saved for ${productName}`);

		await delay(750);
		drawer.close();
	};

	return (
		<Button
			className="submit-nominations-button"
			type="primary"
			onClick={handleSave}
			loading={isSaving}>
			Save
		</Button>
	);
}

export default function NominationsEditorAnchor({ sku, children, onUpdate }) {
	const { title, isLoading } = useTitle(sku);

	const renderHeaderContent = () => {
		if (isLoading || !title.name) {
			return <span>Your nominations</span>;
		}
		return (
			<div>
				<span>Your nominations for </span>
				<em>{title.name}</em>
			</div>
		);
	};

	const renderHeader = () => {
		return (
			<div style={{ textAlign: 'center' }}>{renderHeaderContent()}</div>
		);
	};

	const renderNominationsEditor = (drawer, isLoading) => {
		if (isLoading()) {
			return <LoadingSpinnerInContainer height="200px" />;
		}
		return (
			<div className="nominations-editor-anchor">
				<NomnationsEditor />
				<div style={{ display: 'flex', justifyContent: 'center' }}>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							marginTop: '2rem',
						}}>
						<SubmitNominationsButton
							drawer={drawer}
							productName={title.name}
						/>
						<Button onClick={drawer.close}>Cancel</Button>
					</div>
				</div>
			</div>
		);
	};

	return (
		<ResponsiveDrawerAnchor
			width={{ mobile: '100%', desktop: '650px' }}
			renderDrawerContent={drawer => (
				<UserReviewEditorProvider
					sku={sku}
					onUpdate={onUpdate}
					shareTargetsOptions={{ doIncludeGenreCommunities: false }}>
					{({ isLoading }) => {
						return renderNominationsEditor(drawer, isLoading);
					}}
				</UserReviewEditorProvider>
			)}
			header={<div style={{ padding: 15 }}>{renderHeader()}</div>}>
			{children ? (
				children
			) : (
				<CommunityButton text="Nominate">
					<Icon type="trophy" />
				</CommunityButton>
			)}
		</ResponsiveDrawerAnchor>
	);
}
